import { FormControl, Theme, styled, alpha } from '@material-ui/core';

const FilterFormControl = styled(FormControl)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  alignItems: 'center',
  color: theme.palette.grey['900'],
  display: 'flex',
  flexDirection: 'row',
  fontSize: theme.typography.h3.fontSize,
  padding: theme.spacing(0.5, 2),
  width: '100%',
  '&:first-of-type': {
    background: alpha(theme.palette.common.white, 0.4),
    borderTopLeftRadius: theme.config.defaultBorderRadius,
    borderBottomLeftRadius: theme.config.defaultBorderRadius,
  },
  '&:last-of-type': {
    borderTopRightRadius: theme.config.defaultBorderRadius,
    borderBottomRightRadius: theme.config.defaultBorderRadius,
  },
  '&.disabled': {
    opacity: 0.5,
  },
  '&:has(.MuiSelect-selectMenu:focus)': {
    background: theme.palette.background.default,
  },
  '& .MuiSelect-selectMenu:focus': {
    background: theme.palette.background.default,
  },
}));

export default FilterFormControl;
